import {
  ArrowUp, ArrowDown, Minus, Download, Mail, Camera
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import html2canvas from 'html2canvas';

export { pickTimeBadge, picksHrBadge } from '@/utils/styleHelpers';

export const mailtoExport = (filename) => {
  const subject = encodeURIComponent(`KAIZEN KANRI - ${filename}`);
  const body = encodeURIComponent(`Hi,\n\nPlease find the attached export: ${filename}\n\nGenerated from KAIZEN KANRI Order Picking.\n\nBest regards`);
  window.open(`mailto:?subject=${subject}&body=${body}`);
};

export const buildBewerkerMap = (workers) => {
  const map = {};
  workers.forEach((name, i) => { map[name] = `Bewerker ${i + 1}`; });
  return map;
};

export const anonName = (name, map, isGuest) => isGuest ? (map[name] || name) : name;

export const Delta = ({ value, suffix = '', invert = false }) => {
  if (value === 0 || value === undefined) return <span className="text-muted-foreground text-xs flex items-center gap-0.5"><Minus className="h-3 w-3" /> 0{suffix}</span>;
  const isPositive = invert ? value < 0 : value > 0;
  return (
    <span className={`text-xs font-semibold flex items-center gap-0.5 ${isPositive ? 'text-emerald-600' : 'text-rose-600'}`}>
      {isPositive ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />}
      {value > 0 ? '+' : ''}{value}{suffix}
    </span>
  );
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};

export const capturePng = async (ref, filename) => {
  if (!ref?.current) return;
  const canvas = await html2canvas(ref.current, { backgroundColor: '#ffffff', scale: 2 });
  canvas.toBlob(blob => downloadBlob(blob, filename), 'image/png');
};

export const ExportBar = ({ onPng, onExcel, onPdf, onEmail, loading }) => (
  <div className="flex flex-wrap gap-2">
    {onPng && <Button variant="outline" size="sm" onClick={onPng} disabled={loading} data-testid="export-png"><Camera className="h-3.5 w-3.5 mr-1.5" /> PNG</Button>}
    {onExcel && <Button variant="outline" size="sm" onClick={onExcel} disabled={loading} data-testid="export-excel"><Download className="h-3.5 w-3.5 mr-1.5" /> Excel</Button>}
    {onPdf && <Button variant="outline" size="sm" onClick={onPdf} disabled={loading} data-testid="export-pdf"><Download className="h-3.5 w-3.5 mr-1.5" /> PDF</Button>}
    {onEmail && <Button variant="outline" size="sm" onClick={onEmail} disabled={loading} data-testid="export-email"><Mail className="h-3.5 w-3.5 mr-1.5" /> Email</Button>}
  </div>
);
